import { verifyStripeMode } from '@client/new/api/stripe.api';
import { useUser } from '@client/new/hooks/use-user';
import { navigate, PATHS } from '@client/routes';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { pageBackground } from '@client/new/pages/page-background.css';

export const StripeCallbackPage: React.FC = () => {
  const { influencer, isLoading } = useUser();
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    let isMounted = true;

    const startPolling = () => {
      influencer?.id &&
        verifyStripeMode(Number(influencer.id))
          .then((response) => {
            if (!response) {
              setCount((prev) => prev + 1);
            } else {
              navigate(PATHS.HOME);
              toast.success('Stripe connected successfully');
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
    };

    if (count <= 5) {
      setTimeout(startPolling, 2000);
    } else {
      toast.error('Could not verify account. Please try to connect again.');
      navigate(
        influencer?.id ? PATHS.ADMIN_PAYMENT(influencer.id) : PATHS.HOME,
      );
    }

    return () => {
      isMounted = false;
    };
  }, [count]);

  if (!isLoading && !influencer?.id) {
    return (
      <div className={pageBackground}>
        Missing creator id, cannot verify stripe status.
      </div>
    );
  }

  return (
    <div className={pageBackground}>
      Verifying stripe status, please wait...
    </div>
  );
};
